



import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
@Component
export default class PdStatistics extends AbpBase {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdStatistics/index.vue